module.exports = __webpack_public_path__ + "img/popbg.0e6ff6c0.png";